import { HEADER_LINKS_TYPES } from '../constants/headerLinkTypes';
import { ENVIRONMENT_LINK_ENDPOINTS_NAMES } from '../../../../constants/common/environmentLinkEndpointNames';
import { ALL_USER_ROLES, USER_ROLES } from '../../../../constants/roles/userRoleTypes';

export const californiaHeaderLogo = {
    link: false,
    carrierAffiliatePresent: false,
    carrierAffiliateLogoVisible: false
};

export const california = {
    linkDetails: [
        {
            name: 'language',
            className: ['usa-nav__primary-item gi-main__nav__primary-item link__language'],
            linkClassName:['gi-main__nav__primary-item__link'],
            text: 'header.lang',
            path: '#',
            type: HEADER_LINKS_TYPES.LANGUAGE_SWITCH
        },
        {
            name: 'assistance',
            text: 'header.getAssistance',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--01'],
            ariaClassName: ['extended-nav-section-one'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            dropdown: [
                {
                    name: 'phone',
                    className: ['usa-nav__submenu-item'],
                    text: 'header.getAssistance.phone',
                    type: HEADER_LINKS_TYPES.TEXT,
                    replacements: [ENVIRONMENT_LINK_ENDPOINTS_NAMES.PHONE]
                },
                {
                    name: 'chat',
                    text: 'header.getAssistance.help',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:['icons icons--chat'],
                    path: '#',
                    type: HEADER_LINKS_TYPES.LINK_AS_POPUP,
                    params: ENVIRONMENT_LINK_ENDPOINTS_NAMES.CHAT,
                },
                {
                    name: 'assistance',
                    text: 'header.getAssistance.localAssistance',
                    tooltip: {
                        text: 'header.getAssistance.localAssistance.tooltip',
                        placement: 'right',
                        //replacements: []
                    },
                    className: ['usa-nav__submenu-item'],
                    linkClassName:'icons icons--location-pin',
                    tooltipClassName: 'gi-tooltip',
                    type: HEADER_LINKS_TYPES.TOOLTIP
                },
                {
                    name: 'help',
                    text: 'header.getAssistance.faq',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:['icons icons--faq'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.HELP,
                    type: HEADER_LINKS_TYPES.LINK,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                }
            ]
        },
        {
            name: 'home',
            text: 'header.myAccount',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.HOME,
            type: HEADER_LINKS_TYPES.LINK,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && !errorStatus,
        },
        {
            name: 'securityProfile',
            text: 'header.securityProfile',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.CA_PROFILE_URL,
            type: HEADER_LINKS_TYPES.LINK,
            visible: (environment, currentPath, telexEnabled, errorStatus) => environment.user && !environment.impersonation && USER_ROLES.AGENCYUSERS[environment.user.role] && !errorStatus
        },
        {
            name: 'secureMailbox',
            text: 'header.secureMailbox',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.UNREAD_MESSAGES,
            type: HEADER_LINKS_TYPES.LINK,
            additionalProperties: {
                target: '_blank',
                rel: 'noopener noreferrer'
            },
            visible: (environment, currentPath, telexEnabled, errorStatus) => environment.user && (ALL_USER_ROLES.ASSISTERENROLLMENTENTITY === environment.user.role
                || ALL_USER_ROLES.ISSUER_REPRESENTATIVE === environment.user.role) && !errorStatus
        },
        {
            name: 'login',
            text: 'header.login',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['gi-main__nav__primary-item__link login-btn'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGIN,
            type: HEADER_LINKS_TYPES.LINK,
            visible: environment => environment.anonymous
        },
        {
            name: 'logout',
            text: 'header.logout',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['gi-main__nav__primary-item__link login-btn'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGOUT,
            type: HEADER_LINKS_TYPES.LINK,
            beforeClick : ()=> { localStorage.removeItem('individuals');
                localStorage.removeItem('bobItems');
                localStorage.removeItem('bobItems_selectAll');
                localStorage.removeItem('targetCECName');
                window.traverssingToTransferPage = false; },
            visible: (environment, currentPath, telexEnabled, errorStatus) => !environment.anonymous && !errorStatus
        }
    ]
};